import React from 'react';
import { aiPractices, aiSection } from './data/ai';
import useInView from '../hooks/useInView';

const AiApproach = () => {
  const [ref, inView] = useInView();

  return (
    <section
      id="ai"
      aria-labelledby="ai-title"
      ref={ref}
      className={`section ai reveal${inView ? ' in-view' : ''}`}
    >
      <div className="container">
        <div className="section-head">
          <h2 id="ai-title" className="section-title">
            {aiSection.title}
          </h2>
          <p className="section-intro">{aiSection.intro}</p>
        </div>
        <ol className="practice-list">
          {aiPractices.map((item) => (
            <li className="practice" key={item.lead}>
              <strong>{item.lead}</strong> {item.text}
            </li>
          ))}
        </ol>
        <p className="section-intro mt-4">{aiSection.stack}</p>
      </div>
    </section>
  );
};

export default AiApproach;
